import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { createServerFn } from "@tanstack/react-start";
import { rendererClient } from "../../../../lib/rendererClient";
import { languageKeys } from "@op/puck-types";
import { contextSchema, type Context } from "../../../../utils/context";

const paramsSchema = z.object({
  languageKey: z.enum(languageKeys),
  topicSlug: z.string(),
  pageSlug: z.string(),
});

const getCurrentPageVersionId = createServerFn({
  method: "GET",
})
  .inputValidator(z.object({ params: paramsSchema, context: contextSchema }))
  .handler(
    async ({
      data: {
        params: { languageKey, topicSlug, pageSlug },
        context: { organizationSlug, projectSlug },
      },
    }) => {
      const res = await rendererClient.pages[":organizationSlug"][
        ":projectSlug"
      ][":languageKey"][":topicSlug"][":pageSlug"].$get({
        param: {
          organizationSlug,
          projectSlug,
          languageKey,
          topicSlug,
          pageSlug,
        },
      });
      if (!res.ok) {
        if (res.status === 404) throw notFound();
        else throw new Error("Failed to fetch page");
      }
      const data = await res.json();
      return data;
    },
  );

export const Route = createFileRoute("/$languageKey/$topicSlug/$pageSlug/")({
  params: paramsSchema,
  beforeLoad: async ({ params, context }) => {
    const { currentVersionId } = await getCurrentPageVersionId({
      data: {
        params,
        context: context as Context,
      },
    });
    throw redirect({
      to: "/$languageKey/$topicSlug/$pageSlug/$versionId",
      replace: true,
      statusCode: 307,
      params: {
        languageKey: params.languageKey,
        topicSlug: params.topicSlug,
        pageSlug: params.pageSlug,
        versionId: currentVersionId,
      },
    });
  },
});
